"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnvironmentConfig = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useEnvironmentConfig = () => {
    const { config: { enrichApiPrefix, enrichAIApiPrefix, }, } = (0, react_1.useContext)(context_1.EnrichContext);
    return {
        enrichApiPrefix,
        enrichAIApiPrefix,
    };
};
exports.useEnvironmentConfig = useEnvironmentConfig;
exports.default = exports.useEnvironmentConfig;
